module.exports = __webpack_public_path__ + "static/tsftsotsis-b0e665dff8af4ef9c83015c8692ac8dc.jpg";